const doctorSnippets = document.querySelectorAll('.doctor-snippet');
if(doctorSnippets && doctorSnippets.length > 1) {
	doctorSnippets[0].parentNode.classList.add('multiple-doctors');
}